export default {"src":"/_next/static/image/public/images/ic_location_white_vertical_menu.eea30f90b5832c71c46343ac8c9e3bbb.svg","height":20,"width":20};